"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _reactToastify = require("react-toastify"),
    _glamor = require("glamor"),
    _styledComponents = require("styled-components"),
    _Icon = _interopRequireDefault(require("../Icon"));

require("react-toastify/dist/ReactToastify.css");

var _Background = _interopRequireDefault(require("../Background")),
    _Button = _interopRequireDefault(require("../Button")),
    S = _interopRequireWildcard(require("./styles")),
    _theme = _interopRequireDefault(require("../../styles/theme"));

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

_reactToastify.toast.configure();

var icons = {
  success: "SuccessCircle",
  info: "InfoCircle",
  error: "CloseCircle"
},
    bg = {
  success: _theme["default"].colors.green.main,
  info: _theme["default"].colors.blue.main,
  error: _theme["default"].colors.red.main
},
    ToastContent = function ToastContent(a) {
  var b = a.text,
      c = a.type,
      d = a.toastId,
      e = a.handleClose,
      f = a.cta;
  return _react["default"].createElement(_Background["default"], {
    color: bg[c]
  }, _react["default"].createElement(S.ToastContent, null, _react["default"].createElement(S.ToastContentMessage, null, _react["default"].createElement(S.SvgContainer, {
    onClick: function onClick() {
      return e(d);
    }
  }, _react["default"].createElement(_Icon["default"], {
    name: icons[c]
  })), _react["default"].createElement(S.TextContainer, null, b), f && _react["default"].createElement(S.CtaWrapper, null, _react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: _theme["default"]
  }, _react["default"].createElement(_Button["default"], {
    neutral: !0,
    onClick: f[0]
  }, f[1]))))));
},
    _default = function _default(a) {
  var b = a.text,
      c = a.type,
      d = void 0 === c ? "info" : c,
      e = a.onClose,
      f = void 0 === e ? function () {} : e,
      g = a.cta;
  return (0, _reactToastify.toast)(_react["default"].createElement(ToastContent, {
    text: b,
    type: d,
    cta: g
  }), {
    autoClose: 1750,
    onClose: f,
    closeOnClick: !1,
    closeButton: !1,
    className: (0, _glamor.css)({
      padding: "0 !important"
    }),
    bodyClassName: (0, _glamor.css)({
      padding: "0 !important",
      margin: "0 !important"
    }),
    progressClassName: (0, _glamor.css)({
      background: "white !important"
    })
  }), null;
};

exports["default"] = _default;